var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate, useParams } from "react-router";
import { AccountInfo } from "./account.info";
import { PasswordChange } from "./account.password.change";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AccountActivities } from "./account.activities";
import { BankAccounts } from "./account.bank.accounts";
import { NotificationSettings } from "./account.notification.settings";
import { ContactSettings } from "./account.contact.settings";
import { CookieSettings } from "./account.cookie.settings";
import "./account.css";
import { AccountOrderHistory } from "./account.order.history";
import { auth, authSubject } from "../../store/auth.store";
import { useForceUpdate } from "../../services/misc.functions";
import { isMobile } from "../../App";
import paths from "../../paths";
import { AccountSessions } from "./account.sessions";
// import iconLeft from "../../assets/icons/left-arrow.png";
var subPages = {
    "hesap-bilgileri": _jsx(AccountInfo, {}),
    "sifre-degisikligi": _jsx(PasswordChange, {}),
    "hesap-aktiviteleri": _jsx(AccountActivities, {}),
    "banka-hesaplarim": _jsx(BankAccounts, {}),
    "bildirim-tercihlerim": _jsx(NotificationSettings, {}),
    "iletisim-tercihlerim": _jsx(ContactSettings, {}),
    "cerez-ayarlari": _jsx(CookieSettings, {}),
    "islem-gecmisim": _jsx(AccountOrderHistory, {}),
    "oturumlarim": _jsx(AccountSessions, {}),
};
export function Account() {
    var forceUpdate = useForceUpdate();
    var param = useParams();
    var navigate = useNavigate();
    useEffect(function () {
        var _a;
        var auth_subscriber = authSubject.subscribe(function () {
            var _a;
            if (!auth.member || !((_a = auth.member) === null || _a === void 0 ? void 0 : _a.id)) {
                navigate(paths.login.url);
            }
            forceUpdate();
        });
        if (!auth.member || !((_a = auth.member) === null || _a === void 0 ? void 0 : _a.id)) {
            navigate(paths.login.url);
        }
        return function () {
            auth_subscriber.unsubscribe();
        };
    }, []);
    if (param.page && subPages[param.page]) {
        return subPages[param.page];
    }
    return _jsx(_Fragment, {});
}
export function AccountInfoMenu() {
    var pathname = useLocation().pathname;
    return (_jsxs("div", __assign({ className: "subpage-menu ".concat(isMobile ? "liner-tabs" : "") }, { children: [!isMobile && _jsx("h3", { children: "HESAP B\u0130LG\u0130LER\u0130M" }), isMobile && _jsx("span", __assign({ className: "left-arrow" }, { children: "<" })), _jsx(Link, __assign({ to: "".concat(paths.account.url, "/hesap-bilgileri/"), className: pathname.includes("hesap-bilgileri") ? "active" : "" }, { children: "\u00DCyelik Bilgilerim" })), _jsx(Link, __assign({ to: "".concat(paths.account.url, "/sifre-degisikligi/"), className: pathname.includes("sifre-degisikligi") ? "active" : "" }, { children: "\u015Eifre De\u011Fi\u015Fikli\u011Fi" })), _jsx(Link, __assign({ to: "".concat(paths.account.url, "/hesap-aktiviteleri/"), className: pathname.includes("hesap-aktiviteleri") ? "active" : "" }, { children: "Hesap Aktiviteleri" })), _jsx(Link, __assign({ to: "".concat(paths.account.url, "/banka-hesaplarim/"), className: pathname.includes("banka-hesaplarim") ? "active" : "" }, { children: "Kay\u0131tl\u0131 Banka Hesaplar\u0131m" })), isMobile && _jsx("span", __assign({ className: "right-arrow" }, { children: ">" }))] })));
}
export function OrderHistoryMenu(_a) {
    var gameSlugs = _a.gameSlugs;
    var pathname = useLocation().pathname;
    return (_jsxs("div", __assign({ className: "subpage-menu ".concat(isMobile ? "liner-tabs" : "") }, { children: [!isMobile && _jsx("h3", { children: "\u0130\u015ELEM GE\u00C7M\u0130\u015E\u0130M" }), isMobile && _jsx("span", __assign({ className: "left-arrow" }, { children: "<" })), gameSlugs.map(function (game) {
                return (_jsx(Link, __assign({ to: "".concat(paths.account.url, "/islem-gecmisim/").concat(game.slug, "/"), className: pathname.includes(game.slug) ? "active" : "" }, { children: game.name }), game.slug));
            }), isMobile && _jsx("span", __assign({ className: "right-arrow" }, { children: ">" }))] })));
}
export function NotificationMenu() {
    var pathname = useLocation().pathname;
    return (_jsxs("div", __assign({ className: "subpage-menu ".concat(isMobile ? "liner-tabs" : "") }, { children: [!isMobile && _jsx("h3", { children: "B\u0130LD\u0130R\u0130M AYARLARI" }), _jsx(Link, __assign({ to: "".concat(paths.account.url, "/bildirim-tercihlerim/"), className: pathname.includes("bildirim-tercihlerim") ? "active" : "" }, { children: "Bildirim Tercihlerim" })), _jsx(Link, __assign({ to: "".concat(paths.account.url, "/iletisim-tercihlerim/"), className: pathname.includes("iletisim-tercihlerim") ? "active" : "" }, { children: "\u0130leti\u015Fim Tercihlerim" })), _jsx(Link, __assign({ to: "".concat(paths.account.url, "/cerez-ayarlari/"), className: pathname.includes("cerez-ayarlari") ? "active" : "" }, { children: "\u00C7erez Ayarlar\u0131" }))] })));
}
